import LockTableCellRenderer from "./LockTableCellRenderer";

export default class OvertimeCellRenderer extends LockTableCellRenderer {
    constructor(topBorderClass, cssAdditionalClass) {
        super();
        this.topBorderClass = topBorderClass;
        this.cssAdditionalClass = cssAdditionalClass;
    }

    generateContent(cell) {
        cell.getCellEl().innerHTML = "<div>" + cell.getValue() + "</div>";
    }

    getTopBorderClassName(cell) {
        return this.topBorderClass;
    }

    getComplicatedBorderClassName(cell) {
        let firstRow = cell.getRow().isFirstChildRow();
        let lastRow = cell.getRow().isLastChildRow();
        if (firstRow || lastRow)
            return (firstRow && lastRow) ? "singleDetailsRow" :
                   (firstRow ? "firstDetailsRow" : "lastDetailsRow");
        else
            return "";
    }

    getCellClassName(cell) {
        return "overtimeCell " + this.cssAdditionalClass;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/OvertimeCellRenderer.js